import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import * as agGrid from 'ag-grid-community';
import { HistoryMediConsultComponent } from '../history-medi-consult/history-medi-consult.component';
import { routes } from '../../../../shared/routes/routes';
import { ApiService } from '../../../../api.service';

@Component({
  standalone: false,
  selector: 'app-medi-consult',
  templateUrl: './medi-consult-detail.component.html',
  styleUrls: ['./medi-consult-detail.component.scss']
})
export class MediConsultDetailComponent {
  public pageSize = 10;
  public serialNumberArray: Array<number> = [];
  public totalData = 0;
  showFilter = false;
  private paginationSubscription!: Subscription;
  recordListing: any = [];
  paging: number[] = [];
  dependentData: any = [];
  selected_id: any;
  showApologies: boolean = false;
  subDetail: any;
  currPage: number = 0;
  private prevPageSize: number = 0;
  gridReady = false;
  rowData: any = [];
  gridOptions!: agGrid.GridOptions;
  @ViewChild(HistoryMediConsultComponent) HistoryComponent!: HistoryMediConsultComponent;
  public searchDataValue = '';
  @ViewChild('agGrid') agGrid: AgGridAngular | any;
  public tooltipHideDelay = 2000;
  @ViewChild('filtertextbox') filtertext!: ElementRef;
  SerachedRow: number | undefined;
  selectedTabIndex = 0;
  private gridApi: any;
  private gridColumnApi: any;
  paginationPageSize = 10;
  pages: number[] = [];
  totalPages: number = 0;
  currentPage: number = 1; visiblePageCount = 5;
  totalRecords = 0;
  totalPage: number = 0;
  public tooltipShowDelay = 0;
  lastElementOfPage: number = 0;
  NoRecordsFound!: boolean;
  public routes = routes;
  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    sortable: true,
    filter: true,
    resizable: true,
  };
  userProfile: any = {};
  completionPercentage = 0;
  showApology = false;
  userSubscription: any = {};
  featureNames: any = [];
  showLogoutConfirm = false;
  is_al_carte: boolean = false;
  telemedicineFeature: any;
  reportIdToDelete: any;
  stateData: any;
  showDeleteModal: boolean = false;
  private destroy$ = new Subject<void>();
  tableData: any = [];
  // pagination variables end

  constructor(
    private router: Router, private service: ApiService, private cdr: ChangeDetectorRef
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.stateData = navigation?.extras?.state?.['detailData'];
   
  }

  ngOnInit() {
    const stateData = sessionStorage.getItem('detailData');
    if (stateData) {
      this.stateData = JSON.parse(stateData);
    } else {
      // Optionally redirect back if no data
      this.router.navigate(['/list-page']);
    }
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    this.updateProgress(this.userProfile);
    this.subDetail = JSON.parse(localStorage.getItem('subDetail') || '{}');
  }
  
  
  goBack() {
    window.history.back();
  }

  getFormattedDobWithAge(dob: string): string {
    if (!dob || dob === '0000' || dob.trim() === '') {
      return '';
    }

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const birthDate = new Date(dob);

    if (isNaN(birthDate.getTime()) || birthDate.getFullYear() === 1970) {
      return '';
    }

    const today = new Date();
    const day = birthDate.getDate();
    const month = months[birthDate.getMonth()];
    const year = birthDate.getFullYear();

    let age = today.getFullYear() - year;
    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= day);

    if (!hasBirthdayPassed) {
      age -= 1;
    }

    return `${day} ${month} ${year}, ${age} years`;
  }

  openLogoutPopup() {
    this.showLogoutConfirm = true;
  }

  updateProgress(data: any) {
    const requiredKeys = [
      'first_name', 'last_name', 'dob', 'gender', 'blood_group', 'email', 'height',
      'weight', 'phone', 'alt_phone_number', 'address', 'landmark', 'city', 'state', 'country', 'profile'
    ];
    let filled = 0;
    requiredKeys.forEach(key => {
      const value = data?.[key];
      if (value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '')) {
        filled++;
      }
    });
    this.completionPercentage = Math.round((filled / requiredKeys.length) * 100);
  }
}
